import React, { JSX } from "react";
import { useSelector } from "react-redux";
import { IAppState } from "../../redux/types";
import { useFeatureFlag, usePrevious } from "../hooks/hooks";
import { FLAGS } from "./FeatureFlags";
import { organizationHasUserTag } from "../../redux/devices/selectors";

export const UserTagGate = ({ children }: { children: any }): JSX.Element => {
  const shouldDisplayTag = useSelector(organizationHasUserTag);
  const prev = usePrevious(shouldDisplayTag);
  return (
    <React.Fragment key={shouldDisplayTag + prev}>
      {shouldDisplayTag === true && children}
    </React.Fragment>
  );
};

export const UserTagOrMobileDeviceAsTagGate = ({
  children,
}: {
  children: any;
}): JSX.Element => {
  const shouldDisplayTag = useSelector(organizationHasUserTag);
  const prev = usePrevious(shouldDisplayTag);
  const mobileAsTag = useFeatureFlag(FLAGS.MOBILE_DEVICE_AS_TAG);

  return (
    <React.Fragment
      key={
        shouldDisplayTag +
        prev +
        mobileAsTag.featureVariable +
        mobileAsTag.featurePrev +
        mobileAsTag.needUpdate
      }
    >
      {(shouldDisplayTag === true || mobileAsTag?.featureVariable) && children}
    </React.Fragment>
  );
};

export const NOTUserTagAndNotMobileDeviceAsTagGate = ({
  children,
}: {
  children: any;
}): JSX.Element => {
  const shouldDisplayTag = useSelector(organizationHasUserTag);
  const prev = usePrevious(shouldDisplayTag);
  const mobileAsTag = useFeatureFlag(FLAGS.MOBILE_DEVICE_AS_TAG);
  return (
    <React.Fragment
      key={
        shouldDisplayTag +
        prev +
        mobileAsTag.featureVariable +
        mobileAsTag.featurePrev +
        mobileAsTag.needUpdate
      }
    >
      {shouldDisplayTag === false &&
        mobileAsTag.featureVariable === false &&
        children}
    </React.Fragment>
  );
};
export const NOTUserTagGate = ({
  children,
}: {
  children: any;
}): JSX.Element => {
  const shouldDisplayTag = useSelector(organizationHasUserTag);
  const prev = usePrevious(shouldDisplayTag);
  return (
    <React.Fragment key={shouldDisplayTag + prev}>
      {shouldDisplayTag === false && children}
    </React.Fragment>
  );
};

export const ParadigmaGate = ({ children }: { children: any }): JSX.Element => {
  const { featureVariable, featurePrev, needUpdate } = useFeatureFlag(
    FLAGS.INTEGRATION_PARADIGMA
  );
  return (
    <React.Fragment key={featureVariable + featurePrev + needUpdate}>
      {featureVariable === true && children}
    </React.Fragment>
  );
};

export const MaintenanceAnnouncementGate = ({
  children,
}: {
  children: any;
}): JSX.Element => {
  const { featureVariable, featurePrev, needUpdate } = useFeatureFlag(
    FLAGS.MAINTENANCE_ANNOUNCEMENT
  );
  return (
    <React.Fragment key={featureVariable + featurePrev + needUpdate}>
      {featureVariable === true && children}
    </React.Fragment>
  );
};

export const EnvironmentTemperatureGate = ({
  children,
}: {
  children: any;
}): JSX.Element => {
  const { featureVariable, featurePrev, needUpdate } = useFeatureFlag(
    FLAGS.ENVIRONMENT_TEMPERATURE
  );
  return (
    <React.Fragment key={featureVariable + featurePrev + needUpdate}>
      {featureVariable === true && children}
    </React.Fragment>
  );
};

export const ValeriaGate = ({ children }: { children: any }): JSX.Element => {
  const { email } = useSelector((state: IAppState) => state.userProfile);
  const featureVariable = email === "v.shiryaeva@newlinetechnologies.net";
  return (
    <React.Fragment key={email}>
      {featureVariable === true && children}
    </React.Fragment>
  );
};
